import React from "react";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Maya R.",
    role: "Lash Studio Owner",
    quote:
      "I used to spend two hours a night replying to DMs about pricing. Now my site answers all of it and clients just book themselves in. My evenings are mine again.",
    img: "https://images.unsplash.com/photo-1753351055056-d612233d8036?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    name: "Jordan T.",
    role: "Mindset Coach",
    quote:
      "The funnel they built actually filters my leads — I'm getting fewer messages but way better-qualified clients. Booked sessions are up, and the no-show rate is finally manageable.",
    img: "https://images.unsplash.com/photo-1753351052046-8c6818304a4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
  {
    name: "Coach Diane",
    role: "Riding Academy Director",
    quote:
      "Parents finally see exactly what we offer, when lessons run, and how to register. New trial sign-ups have doubled and I haven't had to chase anyone — they book themselves in.",
    img: "https://images.pexels.com/photos/33867529/pexels-photo-33867529.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section bg-nav-900/40 border-y border-nav-800"
    >
      <div className="container-x">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="eyebrow">
              <span className="h-1.5 w-1.5 rounded-full bg-brand" />
              Real owners. Real outcomes.
            </span>
            <h2 className="mt-4 h-display text-4xl sm:text-5xl">
              More booked sessions.{" "}
              <span className="text-brand">Less time messaging.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex text-amber-400">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-current" />
              ))}
            </div>
            <span className="text-sm font-semibold text-white">
              5.0 average from local owner-operators
            </span>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <figure
              key={r.name}
              data-testid={`testimonial-${i}`}
              className="rounded-2xl bg-nav-900/70 border border-nav-800 p-7 flex flex-col hover:border-brand/40 transition-colors"
            >
              <Quote className="h-7 w-7 text-brand" />
              <blockquote className="mt-4 text-nav-200 text-base leading-relaxed flex-1">
                "{r.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <img
                  src={r.img}
                  alt={r.name}
                  className="h-11 w-11 rounded-full object-cover border border-nav-700"
                />
                <div>
                  <div className="font-semibold text-sm text-white">{r.name}</div>
                  <div className="text-xs text-nav-400">{r.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
